var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"icp__input",style:(_vm.styleObject),attrs:{"type":"color"},domProps:{"value":_vm.value},on:{"input":_vm.$_icp_handleInput,"change":_vm.$_icp_handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }